




































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import Category from '../../models/category'
import Exam from '../../models/exam'
import SlideBar from './SlideBar.vue'

@Component({
  name: 'ExamCategory',
  components: {
    SlideBar
  }
})
export default class ExamCategory extends Vue {
  @Prop({ required: true }) category: Category
  @Prop({ default: 0 }) padding: number
  @Prop({ default: true }) isCategoryRoot: boolean
  @Prop({ default: false }) showEmpty: boolean
  @Prop({ default: () => [] }) exams: Exam[]
  @Prop({ default: false }) visible: boolean
  arrow = "down"

  get categoryExams(): Exam[] {
    return this.category.getExams(this.exams)
  }

  get isShowCategory() {
    return (Number(this.category.examsCount) != 0 || Number(this.category.score) != 0)
  }

  get score() {
    return Number(this.category.score)
  }

  clickPullDown(){
    if(this.arrow == "down") {
      this.arrow = "up"
    } else {
      this.arrow = "down"
    }
    this.visible = !this.visible
  }

  clickCategory() {
    if(Number(this.category.examsCount) > 0) {
      this.$router.push({ query: { list_id: this.category.id.toString() } })
    }
  }

  get isActive() {
    let listId = this.$route.query['list_id']
    if (this.category.subtreeIds.indexOf(Number(listId)) == -1) {
      return false
    } else {
      return true
    }
  }

  get activeClass() {
    let listId = this.$route.query['list_id']
    if (this.category.id == Number(listId)) {
      return "actived"
    }
  }
}
